import { fetcher } from "common/api/Fetcher";
import { ICalendarData, CalendarRecord } from "common/records/Calendar";
import { baseCleanProps } from "common/api/Api";

export interface ICalendarResponse {
  calendar: ICalendarData;
}

export interface ICalendarIndexResponse {
  calendars: ICalendarData[];
}

const url = "api/v1/users/calendars";

export const list = (): Promise<ICalendarIndexResponse> => {
  return fetcher.get(url);
};

export const getCronofyUrl = (): Promise<{ url: string }> => {
  return fetcher.get("auth/cronofy_url");
};

export const syncEvents = (calendar: CalendarRecord): Promise<ICalendarResponse> => {
  const actionUrl = fetcher.joinUrls(url, calendar.id.toString(), "sync");
  return fetcher.post(actionUrl);
};

export const update = (calendar: CalendarRecord): Promise<ICalendarResponse> => {
  const actionUrl = fetcher.joinUrls(url, calendar.id.toString());
  return fetcher.patch(actionUrl, { calendar: baseCleanProps(calendar.toJS()) });
};

export const syncCalendars = () => {
  return fetcher.post(fetcher.joinUrls(url, "sync"));
};
